import { useState } from 'react';
import Sidebar from '../../components/Layout/Sidebar';
import CashBookService from '../../services/CashBookService';

export default function CashIn() {
  const [formData, setFormData] = useState({
    date: "",
    description: "",
    amount: "",
    type: "credit"
  });

  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccess('');
    setError('');

    try {
      const res = await CashBookService.createCashIn(formData);

      // ✅ show success message
      setSuccess(res.message || 'Cash In added successfully!');

      // ✅ reset form
      setFormData({
        date: "",
        description: "",
        amount: "",
        type: "credit"
      });

    } catch (err) {
      setError(
        err.response?.data?.message ||
        'Failed to add Cash In'
      );
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <Sidebar />

      <div className="flex-1 md:ml-64 mt-14 md:mt-0 px-4 py-4 md:px-6 md:py-6">
        <h1 className="text-3xl font-bold text-white bg-black p-4 rounded mb-6">
          Cash In
        </h1>

        <div className="bg-white rounded shadow p-6 max-w-full">

          {/* ✅ Success / Error */}
          {success && (
            <div className="mb-4 p-3 bg-green-100 text-green-800 rounded">
              {success}
            </div>
          )}

          {error && (
            <div className="mb-4 p-3 bg-red-100 text-red-800 rounded">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">

            <input
              type="date"
              className="w-full p-2 border rounded"
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              required
            />

            <input
              type="text"
              placeholder="Description"
              className="w-full p-2 border rounded"
              value={formData.description}
              onChange={(e) => setFormData({ ...formData, description: e.target.value })}
              required
            />

            <input
              type="number"
              placeholder="Amount"
              className="w-full p-2 border rounded"
              value={formData.amount}
              onChange={(e) => setFormData({ ...formData, amount: e.target.value })}
              required
            />

            <input
              className="w-full p-2 border rounded bg-gray-100"
              value="credit"
              readOnly
            />

            <button className="w-full bg-black text-white py-2 rounded">
              Save Cash In
            </button>

          </form>
        </div>
      </div>
    </div>
  );
}
